<template>
  <esg-base-list name="ghg-calculation-history">
    <template #actions>
      <b-row>
        <b-col cols="auto" align-self="center">
          <esg-base-select-box label="대상연도" v-model="year">
            <option value="2024">2024</option>
            <option value="2023">2023</option>
            <option value="2022">2022</option>
          </esg-base-select-box>
        </b-col>
        <b-col cols="auto">
          <esg-base-button variant="primary"
                           :disabled="loading"
                           size="xs"
                           @click="runPcfCalculation">
            <span v-if="!loading" class="align-middle">계산 실행</span>
            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
          </esg-base-button>
        </b-col>
      </b-row>
    </template>
  </esg-base-list>
</template>

<script>
import EsgBaseButton from "@/components/esg/base/EsgBaseButton.vue";
import EsgBaseList from "@/components/esg/base/EsgBaseList.vue";
import EsgBaseSelectBox from "@/components/esg/base/form/EsgBaseSelectBox.vue";

export default {
  name: 'EsgPcfCalculation',
  components: { EsgBaseSelectBox, EsgBaseList, EsgBaseButton },
  data() {
    return {
      loading: false,
      year: new Date().getFullYear()
    }
  },
  methods: {
    async runPcfCalculation() {
      try {
        this.loading = true;
        let response = await axios.post(`esg/lca/calculate/pcf`, [this.year], {
          headers: { Authorization: accessToken() }
        })

        let results = response.data;
        for (const key in results) {
          if (results[key].result !== "Success") {
            await this.showError(new Error("계산에 실패하였습니다"));
            return;
          }
        }
        await this.$store.commit("setMessage", "온실가스 배출량 계산이 완료되었습니다.");
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    }
  },
}
</script>